import { Module, VuexModule, getModule, Mutation } from 'vuex-module-decorators';
import store from '@/store';

@Module({
  namespaced: true,
  name: 'history',
  store,
  dynamic: true
})

class HistoryData extends VuexModule {

  prev: string | undefined = ""

  @Mutation
  setPrev(prev: string) {

    this.prev = prev
  }

}

export default getModule(HistoryData)


